import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowOutward } from "@mui/icons-material";
import { FantasyPlayer } from "../../../models/FantasyPlayer";
import PlayerSlotV2 from "../../FantasyPage/PlayerSlotV2";
import cardStyles from "../../FantasyPage/PlayerSlotV2.module.css";
import PlayerTeamHistoryComponent from "../../../components/PlayerTeamHistoryComponent";
import styles from "../Predict.module.css";

interface RosterStripProps {
  teamId: string;
  teamName: string;
  teamLogo?: string;
  avgElo?: number;
  players: FantasyPlayer[];
}

/**
 * The clicked team's players under the editor: the same fantasy cards (photo, rarity, price) and
 * per-player team history as before the redesign, inside the new panel.
 */
const RosterStrip: React.FC<RosterStripProps> = ({ teamId, teamName, teamLogo, avgElo, players }) => {
  const { t } = useTranslation("pages");
  const [showHistory, setShowHistory] = useState(false);

  return (
    <section className={`${styles.panel} ${styles.roster}`} aria-label={teamName}>
      <div className={styles.panelHead}>
        {teamLogo && <img className={styles.rosterLogo} src={teamLogo} alt="" />}
        <h2 className={styles.panelTitle}>{teamName}</h2>
        {!!avgElo && <span className={styles.eloBadge}>{t("predict.avgElo", { elo: avgElo })}</span>}
        <span className={styles.spacer} />
        <button type="button" className={styles.ghostButton} aria-pressed={showHistory} onClick={() => setShowHistory((v) => !v)}>
          {showHistory ? t("predict.hideHistory") : t("predict.showHistory")}
        </button>
        <Link className={styles.outLink} to={`/team/${teamId}`} target="_blank" rel="noopener noreferrer">
          {t("predict.teamPage")}
          <ArrowOutward sx={{ fontSize: 14, opacity: 0.55 }} />
        </Link>
      </div>
      <div className={styles.rosterBody}>
        <div className={cardStyles.playerGrid}>
          {players.map((player) => (
            <div key={player.account.steamID} className={styles.rosterPlayer}>
              <PlayerSlotV2 player={player} compact />
              {showHistory && (
                <div className={styles.rosterHistory}>
                  <PlayerTeamHistoryComponent steamId={player.account.steamID} isDark compact appearance="flat" />
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default RosterStrip;
